// 自动生成，请勿手动修改

export interface AttributeInfo {
  name: string;
  color: string;
}

export const ATTRIBUTES: AttributeInfo[] = [
  {
    name: '光',
    color: '#FFB833',
  },
  {
    name: '冰',
    color: '#98D8D8',
  },
  {
    name: '地',
    color: '#C7A054',
  },
  {
    name: '幻',
    color: '#F85888',
  },
  {
    name: '幽',
    color: '#7B62A3',
  },
  {
    name: '恶',
    color: '#705848',
  },
  {
    name: '普通',
    color: '#A8A878',
  },
  {
    name: '机械',
    color: '#B8B8D0',
  },
  {
    name: '武',
    color: '#C03028',
  },
  {
    name: '毒',
    color: '#A040A0',
  },
  {
    name: '水',
    color: '#4DA6FF',
  },
  {
    name: '火',
    color: '#FF6B3D',
  },
  {
    name: '电',
    color: '#F9CF30',
  },
  {
    name: '翼',
    color: '#9DB7F5',
  },
  {
    name: '草',
    color: '#6BC44F',
  },
  {
    name: '萌',
    color: '#EE99AC',
  },
  {
    name: '虫',
    color: '#A8B820',
  },
  {
    name: '龙',
    color: '#7866D5',
  },
];

export const ATTRIBUTE_COLOR_MAP: Record<string, string> = Object.fromEntries(
  ATTRIBUTES.map((a) => [a.name, a.color]),
);
